const Minus = (props) => (
  <svg width='12' height='2' viewBox='0 0 12 2' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M0 2V0H12V2H0Z' fill='#333333' />
  </svg>
);

export default Minus;
